export const getWeightInText = (weight) => {
  return `${weight < 1 ? (weight * 1000) / 1 : weight / 1} ${
    weight < 1 ? "Grams" : "Kg"
  }`;
};
